{
  "greeting": "您好！我可以如何帮助您选择葡萄酒？",
  "thinking": "✨ 思考中...",
  "thinkingStep": "✨ 思考中... {step}",
  "askAboutWine": "例如：1990年代波尔多红酒约$1500 | 勃根地村庄白酒低于$600",
  "askAboutWineFirst": "我想寻找葡萄酒...（产地 + 葡萄酒颜色 + 年份 + 价格）",
  "waitingForResponse": "等待回应中...",
  "dailyLimitReached": "您已达到今日的咨询限额。请于香港时间 00:00 后再次访问。",
  "chatHistory": "您的聊天记录",
  "noChatHistory": "尚无聊天记录",
  "startConversation": "开始对话以查看记录",
  "backToChat": "返回聊天",
  "newChat": "新聊天",
  "history": "记录",
  "search": "搜索",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "您的专属葡萄酒顾问",
  "chat": "聊天",
  "chatNumber": "聊天 {number}",
  "wineRecommended": "推荐了 {count} 款葡萄酒",
  "winesRecommended": "推荐了 {count} 款葡萄酒",
  "justNow": "刚刚",
  "minuteAgo": "{count} 分钟前",
  "minutesAgo": "{count} 分钟前",
  "hourAgo": "{count} 小时前",
  "hoursAgo": "{count} 小时前",
  "dayAgo": "{count} 天前",
  "daysAgo": "{count} 天前",
  "noMessagesYet": "尚无消息",
  "perBottle": "每瓶",
  "priceNA": "价格不详",
  "buyNow": "立即购买",
  "moreInformation": "更多信息",
  "share": {
    "button": "分享",
    "title": "分享对话",
    "description": "使用下面的链接与朋友分享这段对话：",
    "generating": "正在生成分享链接...",
    "error": "生成分享链接失败",
    "copy": "复制",
    "copied": "已复制！",
    "note": "注意：此链接将在30天后过期。当有人打开此链接时，他们将看到这段对话的副本。"
  },
  "checkOutWine": "看看这款葡萄酒：{name} {vintage}",
  "linkCopied": "链接已复制到剪贴板！",
  "contactWhatsApp": "通过 WhatsApp 联系我们以获得更多选择",
  "errorLoadingWine": "抱歉，无法加载葡萄酒详细信息。",
  "errorOccurred": "获取回应时发生错误。",
  "you": "您",
  "welcome": {
    "intro": "我是Zyra，您的智能葡萄酒顾问，我可以为您建议：  ",
    "features": {
      "globalMarket": "跨市场（英国、法国、香港）货源实时报价和数量",
      "personalized": "个人化葡萄酒建议 按预算提供最适合的选择",
      "instantCheckout": "结帐付款、物流配送和仓存选项"
    },
    "question": "Zyra 诚意为您推荐...",
    "trendingPrompts": "范例查询  （目前货币设定是港币）",
    "promptExamples": {
      "title": "如何询问：",
      "good": "✓ 良好范例：",
      "bad": "✗ 避免没有预算的查询："
    },
    "prompts": {
      "bordeaux": "800美元左右的波尔多红酒",
      "champagne": "2000美元以下的种植者香槟",
      "firstGrowth": "2010-2019年一级酒庄最佳报价"
    }
  },
  "feedback": {
    "helpful": "这很有帮助",
    "notHelpful": "这没有帮助",
    "thankYou": "感谢您的反馈！",
    "whatDidYouLike": "您喜欢什么？",
    "whatCouldBeImproved": "有什么可以改进的？",
    "category": "类别",
    "selectCategory": "选择类别",
    "categories": {
      "accuracy": "准确性",
      "helpfulness": "实用性",
      "responseSpeed": "回应速度",
      "clarity": "清晰度",
      "other": "其他"
    },
    "comments": "意见",
    "placeholder": "告诉我们更多关于您的体验...",
    "cancel": "取消",
    "submit": "提交反馈",
    "submitting": "提交中..."
  },
  "auth": {
    "limitReached": "已达每日限制",
    "signUpToday": "注册以获得更多消息",
    "limitMessage": "您已达到每日消息限制。注册免费账户以继续聊天。",
    "benefitsMessage": "创建免费账户以继续聊天并在各设备上保存您的聊天记录。",
    "remainingMessages": "您今天还有 {count} 条消息",
    "signUp": "注册",
    "login": "登录",
    "loggedInAs": "已登录为 {email}",
    "logout": "退出登录"
  }
}
